import type {
  PortfolioConfigurationGroupMacro,
  PortfolioConfigurationProductGroup,
} from 'src/services/mappings/portfolio/portfolio.types'
import type { TailwindColor } from 'src/utils/getColor'
import { PRODUCT_COLORS } from 'src/utils/getColor.const'
import {
  PORTFOLIO_CONFIGURATION_GROUP_MACRO,
  PORTFOLIO_CONFIGURATION_PRODUCT_GROUP,
} from './portfolio.const'

export const GROUP_MACRO_COLORS = {
  [PORTFOLIO_CONFIGURATION_GROUP_MACRO.financier]: PRODUCT_COLORS.cyan,
  [PORTFOLIO_CONFIGURATION_GROUP_MACRO.immobilier]: PRODUCT_COLORS.lightGreen,
  [PORTFOLIO_CONFIGURATION_GROUP_MACRO.biensMobiliers]: PRODUCT_COLORS.beige,
  [PORTFOLIO_CONFIGURATION_GROUP_MACRO.actifsPro]: PRODUCT_COLORS.lemon,
  [PORTFOLIO_CONFIGURATION_GROUP_MACRO.emprunt]: PRODUCT_COLORS.brown,
  [PORTFOLIO_CONFIGURATION_GROUP_MACRO.capitauxPrevoyance]: PRODUCT_COLORS.pink,
} as const satisfies Record<PortfolioConfigurationGroupMacro, TailwindColor>

export const PRODUCT_GROUP_COLORS = {
  [PORTFOLIO_CONFIGURATION_PRODUCT_GROUP.av]: PRODUCT_COLORS.cyan,
  [PORTFOLIO_CONFIGURATION_PRODUCT_GROUP.cpteDepot]: PRODUCT_COLORS.purple,
  [PORTFOLIO_CONFIGURATION_PRODUCT_GROUP.emprunt]: PRODUCT_COLORS.brown,
  [PORTFOLIO_CONFIGURATION_PRODUCT_GROUP.epargne]: PRODUCT_COLORS.blue,
  [PORTFOLIO_CONFIGURATION_PRODUCT_GROUP.furniture]: PRODUCT_COLORS.beige,
  [PORTFOLIO_CONFIGURATION_PRODUCT_GROUP.immob]: PRODUCT_COLORS.lightGreen,
  [PORTFOLIO_CONFIGURATION_PRODUCT_GROUP.mobiliere]: PRODUCT_COLORS.green,
  [PORTFOLIO_CONFIGURATION_PRODUCT_GROUP.nonDefini]: PRODUCT_COLORS.default,
  [PORTFOLIO_CONFIGURATION_PRODUCT_GROUP.pea]: PRODUCT_COLORS.orange,
  [PORTFOLIO_CONFIGURATION_PRODUCT_GROUP.prevoyance]: PRODUCT_COLORS.pink,
  [PORTFOLIO_CONFIGURATION_PRODUCT_GROUP.pro]: PRODUCT_COLORS.lemon,
  [PORTFOLIO_CONFIGURATION_PRODUCT_GROUP.retraite]: PRODUCT_COLORS.darkBlue,
} as const satisfies Record<PortfolioConfigurationProductGroup, TailwindColor>
